import { KTIcon } from "../../../../_metronic/helpers";

const ConfirmOrgModalHeader = ({
  setOrgId,
  openConfirmOrgModal,
  setOpenConfirmOrgModal
}) => {
  return (
    <div className="modal-header">
      <h2 className="fw-bolder">{openConfirmOrgModal?.type === 'Approve' ? 'Approve' : 'Delete'} Organization</h2>
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenConfirmOrgModal({
          isOpen: false,
          type: null
          });
          setOrgId(null);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { ConfirmOrgModalHeader };
